import { render, staticRenderFns } from "./MenuFooter.vue?vue&type=template&id=168fe66f"
import script from "./MenuFooter.vue?vue&type=script&lang=ts"
export * from "./MenuFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports